import React from "react";

export const Residential = [
  <div className="slideContainer">
    <h4 className="slideTitle">Het aardwarmteproject Leeuwarden</h4>
    <div className="slideText">
      <p>
        Warmte die diep in de grond zit gebruiken om huizen, gebouwen, tuinbouw
        en industrie te verwarmen. Dit is het idee dat ten grondslag ligt aan
        het aardwarmteproject in Leeuwarden. Energie Beheer Nederland (EBN) en
        Shell Geothermie, Ennatuurlijk en initiator Bouwgroep Dijkstra Draisma
        zijn onderdeel van het consortium Warmte van Leeuwarden om het bestaande
        aardwarmteproject in Leeuwarden verder te helpen realiseren. Het project
        zal een belangrijke bijdrage leveren aan de verduurzaming van de
        warmtevraag van Leeuwarden.
      </p>
      <p>
        ECW heeft als oorspronkelijke operator besloten zich volledig te
        concentreren op de energie- en watertoepassingen op Agriport en in
        Andijk. Shell Geothermie zal de rol van ECW binnen het consortium
        overnemen. EBN zet haar kennis en expertise van de ondergrond in en is
        in die hoedanigheid als partner betrokken. Het warmtenet dat de warmte
        naar de klanten transporteert, wordt ontwikkeld en geëxploiteerd door
        Ennatuurlijk.
      </p>
    </div>
    <h4 className="slideTitle">Verduurzaming van warmtevoorziening</h4>
    <div className="slideText">
      <p>
        Shell ziet in Nederland goede kansen voor het inzetten van aardwarmte
        voor de verduurzaming van de warmtevoorziening. Aardwarmte is duurzamere
        warmtebron aangezien er bij de productie van aardwarmte bijna geen CO₂
        vrijkomt.Shell Geothermie heeft kennis en expertise van de ondergrond,
        de winning van energie en het realiseren van grote projecten. Met
        aardwarmteprojecten zoals in Leeuwarden wil Shell een bijdrage leveren
        aan de Nederlandse energietransitie.
      </p>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      How Shell City Solutions helps cities navigate the energy transition
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/How Shell City Solutions helps cities navigate the energy transition.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-residential-success-story-video-02.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">The world of sonnen</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/The world of sonnen (english).mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-residential-success-story-video-03.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
    <>
    <div className="slideContainer slide_solidColour text-center">
      <img
        src="images/residential-sonnen.jpg"
        width="900px"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">Van raffinaderij tot woonkamer</h4>
    <div className="slideText">
      <p>
        Wat als je loze warmte kunt gebruiken voor andere doeleinden? Dit is
        exact het idee van het Pernis restwarmte initiatief. Shell, Havenbedrijf
        Rotterdam en Warmtebedrijf Rotterdam bundelen hun krachten om energie
        nog efficiënter te gebruiken.
      </p>
      <p>
        Shell Pernis heeft installaties gebouwd die het mogelijk maken om
        overtollige warmte uit de raffinaderij af te voeren. Havenbedrijf
        Rotterdam zorgt voor het transport tussen de raffinaderij en het
        bestaande warmtenet. Het Warmtebedrijf Rotterdam verzorgt de aansluiting
        op het bestaande warmtenet, het beheer, de operationele aspecten en het
        onderhoud ervan. Door deze samenwerking krijgt de industriële restwarmte
        een tweede leven en verwarmt het circa 16.000 Rotterdamse huishoudens.
        Deze huishoudens hoeven zelf geen aardgas meer te verstoken om warmte op
        te wekken waardoor de CO₂-uitstoot van die huishoudens verminderd is. De
        overgang naar restwarmte levert de regio jaarlijks een CO₂-reductie op
        van 35.000 ton. “Bij dit soort ontwikkelingen is samenwerking tussen het
        bedrijfsleven en de overheid de sleutel tot succes’’ zegt Marjan van
        Loon, President-directeur van Shell Nederland.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/6bfd3a5e-4a78-4389-b464-8b92eb505c87-cropped.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
  <>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p class="statsIntro">
          <strong>
            “Bij dit soort ontwikkelingen is samenwerking tussen het
            bedrijfsleven en de overheid de sleutel tot succes’’
          </strong>
          <br />
          <br />
          Marjan van Loon, President-Directeur van Shell Nederland.
        </p>
      </div>
      <div className="colRight col50 solidColourContainer stats">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">16.000</span>
            <br />
            Rotterdamse huishoudens verwarmd
          </p>
        </div>
      </div>
    </div>
  </>,
];
